import i18n from '@/services/i18n'

const numberReg = /^\d{11}$/

const RULES = {
  provider_pickup_type: (supportedPickupTypes) => {
    return [
      {
        validator: async (_, value) => {
          if (!supportedPickupTypes.includes(value)) {
            return Promise.reject(i18n.t('common.validate.optionInvalid'))
          }
          return Promise.resolve()
        },
      },
    ]
  },
  /** 付款方式  */
  provider_pay_type: () => {
    return [
      {
        validator: async (_, value) => {
          if (!value) {
            return Promise.reject(i18n.t('common.formValidRequired'))
          }
          return Promise.resolve()
        },
      },
    ]
  },

  /** 增值服务  */
  provider_payment_type: () => {
    return [
      {
        validator: async (_, value) => {
          if (!value) {
            return Promise.reject(i18n.t('common.formValidRequired'))
          }
          return Promise.resolve()
        },
      },
    ]
  },
  /** 代收货款 */
  provider_cod_amount: ({ currencyCode, supportedCOD, isCod }) => {
    return [
      {
        validator: async (_, value) => {
          if (typeof value === 'number') {
            value = value + ''
          }
          if (!supportedCOD) {
            return Promise.resolve()
          }
          if (!isCod) {
            return Promise.resolve()
          }
          if (!value || value === '0') {
            // 代收货款不支持0
            return Promise.reject(i18n.t('common.formValidRequired'))
          }

          /**
           * 不允许有小数
           * @description
           * 以下国家/地区币种不允许有小数
           */
          const noDecimals = ['TWD', 'VND', 'IDR'].includes(currencyCode)
          if (noDecimals) {
            // 不能有小数位
            if (value?.toString()?.indexOf('.') !== -1 || Number(value) < 0) {
              return Promise.reject(i18n.t('order.price.parcelItemsPriceLimit'))
            }
          } else {
            // 小数位不能大于2`
            if (!/^\d+(\.\d{1,2})?$/.test(value) || Number(value) < 0) {
              return Promise.reject(i18n.t('order.price.parcelItemsPriceLimitHasMaxDot', { max: 2 }))
            }
          }

          return Promise.resolve()
        },
      },
    ]
  },
  /** 服务编码 */
  provider_channel_seller_id: ({ noOptions = false }) => {
    return [
      {
        validator: async (_, value: string) => {
          if (noOptions) {
            return Promise.reject(i18n.t('logistics.create.submitErrorMonthlyAccounts'))
          }

          const length = value?.length
          if (!length) {
            return Promise.reject(i18n.t('common.formValidRequired'))
          }
          return Promise.resolve()
        },
      },
    ]
  },

  /** 证件号码 */
  provider_consignee_id_num: ({ isRequired, channelCode, countryCode }) => {
    return [
      {
        validator: async (_, value: string) => {
          const length = value?.length
          if (isRequired && !length) {
            return Promise.reject(i18n.t('common.formValidRequired'))
          }

          // 如果收件国家是秘鲁，并且是纬狮渠道
          if (countryCode === 'PE' && channelCode === 'LION' && length && length !== 8) {
            return Promise.reject(i18n.t(`common.formValidLength${length > 8 ? 'LessThan' : 'MoreThan'}`, { length: 8 }))
          }

          if (length > 32) {
            return Promise.reject(i18n.t('common.formValidLengthLessThan', { length: 32 }))
          }
          return Promise.resolve()
        },
      },
    ]
  },

  /** 证件类型 */
  provider_consignee_id_type: ({ isRequired }) => {
    return [
      {
        validator: async (_, value: number) => {
          if (isRequired && !value) {
            return Promise.reject(i18n.t('common.formValidRequired'))
          }
          return Promise.resolve()
        },
      },
    ]
  },

  /** EORI号码 */
  provider_custom_id_no: ({ isRequired }) => {
    return [
      {
        validator: async (_, value: string) => {
          if (isRequired && !value) {
            return Promise.reject(i18n.t('common.formValidRequired'))
          }
          const length = value?.length
          if (length > 32) {
            return Promise.reject(i18n.t('common.formValidLengthLessThan', { length: 32 }))
          }
          return Promise.resolve()
        },
      },
    ]
  },
  /** 揽收日期  */
  provider_pickup_date: ({ required }) => {
    return [
      {
        validator: async (_, value) => {
          if (!required) return Promise.resolve()

          if (!value) {
            return Promise.reject(i18n.t('common.formValidRequired'))
          }
        },
      },
    ]
  },

  /** 揽收时间段  */
  provider_pickup_time_slots: ({ required }) => {
    return [
      {
        validator: async (_, value) => {
          if (!required) return Promise.resolve()

          if (!value) {
            return Promise.reject(i18n.t('common.formValidRequired'))
          }
        },
      },
    ]
  },

  /** 税号 */
  provider_tax_no: ({ isRequired, channelCode, countryCode, departureCity, requireName }) => {
    const requireChannelName = 'JNE'
    return [
      {
        validator: async (_, value: string) => {
          const require = channelCode === requireChannelName && departureCity === requireName

          const length = value?.length
          if (!length && (isRequired || require)) {
            return Promise.reject(i18n.t('common.formValidRequired'))
          }

          // 如果是纬狮渠道, 并且收件国家是巴西BR或者秘鲁PE/智利CL
          if (channelCode === 'LION' && length) {
            if (countryCode === 'BR' && !numberReg.test(value)) {
              return Promise.reject(i18n.t('common.formValidMaxWithNumber', { length: 11 }))
            }

            if (countryCode === 'PE' && length !== 11) {
              return Promise.reject(i18n.t(`common.formValidLength${length > 11 ? 'LessThan' : 'MoreThan'}`, { length: 11 }))
            }

            if (countryCode === 'CL' && length !== 9) {
              return Promise.reject(i18n.t('common.formValidMaxWithWords', { length: 9 }))
            }
          }

          if (length > 32) {
            return Promise.reject(i18n.t('common.formValidLengthLessThan', { length: 32 }))
          }
          return Promise.resolve()
        },
      },
    ]
  },

  /** 税号类型类型 */
  provider_tax_type: ({ isRequired }) => {
    return [
      {
        validator: async (_, value: number) => {
          if (isRequired && !value) {
            return Promise.reject(i18n.t('common.formValidRequired'))
          }
          return Promise.resolve()
        },
      },
    ]
  },
  /** 派送日期 */
  provider_delivery_date: ({ required }) => {
    return [
      {
        validator: async (_, value) => {
          if (!required) return Promise.resolve()

          if (!value) {
            return Promise.reject(i18n.t('common.formValidRequired'))
          }
        },
      },
    ]
  },
  /** 派送时间 */
  provider_delivery_time: ({ required }) => {
    return [
      {
        validator: async (_, value) => {
          if (!required) return Promise.resolve()

          if (!value) {
            return Promise.reject(i18n.t('common.formValidRequired'))
          }
        },
      },
    ]
  },

  /** 发票号 */
  provider_invoice_no: ({ isRequired }) => {
    const maxLen = 35
    return [
      {
        validator: async (_, value: string) => {
          const length = value?.length
          if (!length && isRequired) {
            return Promise.reject(i18n.t('common.formValidRequired'))
          }

          if (length > maxLen) {
            return Promise.reject(i18n.t('common.formValidLengthLessThan', { length: maxLen }))
          }

          return Promise.resolve()
        },
      },
    ]
  },

  provider_invoice_date: ({ isRequired }) => {
    return [
      {
        validator: async (_, value: string) => {
          if (isRequired && !value) {
            throw new Error(i18n.t('common.select.placeholder'))
          }
          return true
        },
      },
    ]
  },

  /** EORI号码 */
  provider_package_desc: ({ isRequired }) => {
    const max = 60

    return [
      {
        validator: async (_, value: string) => {
          const text = value?.trim()

          if (isRequired && !text) {
            return Promise.reject(i18n.t('common.formValidRequired'))
          }
          const length = text?.length
          if (length > max) {
            return Promise.reject(i18n.t('common.formValidLengthLessThan', { length: max }))
          }
          return Promise.resolve()
        },
      },
    ]
  },

  /** tax */
  provider_taxation: ({ isRequired, channelCode, departureCity, requireName }) => {
    const max = 16
    const requireChannelName = 'JNE'

    return [
      {
        validator: async (_, value: string) => {
          const text = value?.toString()

          const require = channelCode === requireChannelName && departureCity === requireName

          if ((isRequired || require) && !text) {
            return Promise.reject(i18n.t('common.formValidRequired'))
          }

          const length = text?.length
          if (length > max) {
            return Promise.reject(i18n.t('common.formValidLengthLessThan', { length: max }))
          }
          return Promise.resolve()
        },
      },
    ]
  },
}

export default RULES
